import { useState, useCallback } from 'react';
import {
  getDiagnosticSlots,
  saveDiagnosticSlot,
} from '../services/subscriberWalletService';

export const useDiagnosticSlots = (currentRole) => {
  const [slots, setSlots] = useState([]);
  const [slotType, setSlotType] = useState('');
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [savingSlot, setSavingSlot] = useState(false);

  const loadSlots = useCallback(async (orderId, slotDate, showNotification) => {
    if (!orderId) return;
    setLoadingSlots(true);
    try {
      const response = await getDiagnosticSlots(currentRole, orderId, slotDate);
      if (response?.metadata?.api_status === true) {
        const raw = response.msg?.slots;
        setSlots(Array.isArray(raw) ? raw : (raw?.slots || []));
        setSlotType(response.msg?.slot_type || '');
      } else {
        throw new Error(response?.msg?.error || 'Failed to load slots');
      }
    } catch (error) {
      showNotification(error.message || 'Failed to load slots', 'error');
    } finally {
      setLoadingSlots(false);
    }
  }, [currentRole]);

  const saveSlot = useCallback(async (orderId, slotData, showNotification) => {
    if (!orderId || (!slotData?.slot_id && !slotData?.slot_date)) {
      showNotification('Please select a slot', 'error');
      return false;
    }
    setSavingSlot(true);
    try {
      const response = await saveDiagnosticSlot(currentRole, orderId, {
        order_id: orderId,
        slot_id: slotData.slot_id,
        slot_date: slotData.slot_date,
        slot_time: slotData.slot_time || '',
      });
      if (response?.metadata?.api_status === true) {
        setSelectedSlot(slotData);
        showNotification('Slot saved successfully', 'success');
        return true;
      } else {
        throw new Error(response?.msg?.error || 'Failed to save slot');
      }
    } catch (error) {
      showNotification(error.message || 'Failed to save slot', 'error');
      return false;
    } finally {
      setSavingSlot(false);
    }
  }, [currentRole]);

  return {
    slots,
    slotType,
    selectedSlot,
    setSelectedSlot,
    loadingSlots,
    savingSlot,
    loadSlots,
    saveSlot,
  };
};
